import tottiothugIcon from './Avatar_tottiothug.png';
import tottiothugIcon1x from './Avatar_tottiothug@1x.png';
import w5556Icon from './Avatar_w5556-4.png';
import w5556Icon1x from './Avatar_w5556-4@1x.png';

import tottiothugIconWebP from './Avatar_tottiothug.webp';
import tottiothugIcon1xWebP from './Avatar_tottiothug@1x.webp';
import w5556IconWebP from './Avatar_w5556-4.webp';
import w5556Icon1xWebP from './Avatar_w5556-4@1x.webp';

import coolTrend from './cooltrend.png';

export default {
  Cool_Trend_4You: {
    '1x': coolTrend,
    '2x': coolTrend,
    '1xWebP': coolTrend,
    '2xWebP': coolTrend,
  },
  tottiothug: {
    '1x': tottiothugIcon1x,
    '2x': tottiothugIcon,
    '1xWebP': tottiothugIcon1xWebP,
    '2xWebP': tottiothugIconWebP,
  },
  'w5556-4': {
    '1x': w5556Icon1x,
    '2x': w5556Icon,
    '1xWebP': w5556Icon1xWebP,
    '2xWebP': w5556IconWebP,
  },
};
